export default "__VITE_ASSET__v8fLc_xi__"